<template>
  <div width="100%">
    <div class="buttons-row">
      <div class="ma-1">
        <cs-button id="btn-click-me" primary label="Click Me" @click="onClickMe"></cs-button>
      </div>
      <div class="ma-2 text-primary">Clicks {{ noOfClicks }}</div>
    </div>
    <div class="buttons-row">
      <div class="ma-1">
        <cs-button
          :disabled="disabled"
          large
          primary
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          primary
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          small
          primary
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button large primary left-icon="mdi-star" label="Left Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button primary right-icon="mdi-check-circle" label="Right Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button small primary label="Text only"></cs-button>
      </div>
    </div>
    <div class="buttons-row">
      <div class="ma-1">
        <cs-button
          large
          :disabled="disabled"
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          small
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button large left-icon="mdi-star" label="Left Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button right-icon="mdi-check-circle" label="Right Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button small label="Text only"></cs-button>
      </div>
    </div>
    <div class="buttons-row">
      <div class="ma-1">
        <cs-button
          large
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          disabled
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          disabled
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          small
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          disabled
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button large disabled left-icon="mdi-star" label="Left Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button disabled right-icon="mdi-check-circle" label="Right Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button small disabled label="Text only"></cs-button>
      </div>
    </div>
    <div class="buttons-row">
      <div class="ma-1">
        <cs-button
          large
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          delete
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          delete
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          small
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          delete
          label="Button"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button large delete left-icon="mdi-star" label="Left Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button delete right-icon="check_circle" label="Right Icon"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button small delete label="Text only"></cs-button>
      </div>
    </div>
    <div class="buttons-row">
      <div class="ma-1">
        <cs-button
          large
          primary
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Loader"
          :loading="loading"
          @click="onClickLoad"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          primary
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Loader"
          :loading="loading"
          @click="onClickLoad"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          primary
          small
          left-icon="mdi-plus-circle-outline"
          right-icon="mdi-plus-circle-outline"
          label="Loader"
          :loading="loading"
          @click="onClickLoad"
        ></cs-button>
      </div>
    </div>
    <div class="buttons-row" style="background-color: RGB(245, 245, 245)">
      <div class="ma-1">
        <cs-button information title="Title only"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button information title="Title" description="Description"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button information title="Title" :description="longDescription"></cs-button>
      </div>
    </div>
    <div class="buttons-row" style="background-color: RGB(245, 245, 245)">
      <div class="ma-1">
        <cs-button information title="Title only" left-icon="mdi-file-video"></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          information
          left-icon="mdi-file-video"
          title="Title"
          description="Description"
        ></cs-button>
      </div>
      <div class="ma-1">
        <cs-button
          information
          left-icon="mdi-file-video"
          title="Title"
          :description="longDescription"
        ></cs-button>
      </div>
    </div>
    <div class="mt-2 colorDefinition">
      <div class="pa-1 buttons-row">
        <div>Button Colors</div>
      </div>
      <div style="display: flex; flex-wrap: wrap">
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme.primary }">
          <div class="colorDesc">
            <div class="colorText">Default/Focus</div>
            <span class="colorCode">{{ currentTheme.primary }}</span>
          </div>
        </div>
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme['primary-lighten-1'] }">
          <div class="pb-0 colorDesc">
            <div class="colorText">Hover</div>
            <span class="colorCode">{{ currentTheme['primary-lighten-1'] }}</span>
          </div>
        </div>
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme['primary-darken-1'] }">
          <div class="pb-0 colorDesc">
            <div class="colorText">Pressed</div>
            <span class="colorCode">{{ currentTheme['primary-darken-1'] }}</span>
          </div>
        </div>
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme.secondary }">
          <div class="pb-0 colorDesc text-black-lighten-2">
            <div class="colorText">Default/Focus</div>
            <span class="colorCode">{{ currentTheme.secondary }}</span>
          </div>
        </div>
        <div
          class="colorPill ma-1"
          :style="{ backgroundColor: currentTheme['secondary-darken-1'] }"
        >
          <div class="pb-0 colorDesc text-black-lighten-2">
            <div class="colorText">Hover/Disabled</div>
            <span class="colorCode">{{ currentTheme['secondary-darken-1'] }}</span>
          </div>
        </div>
        <div
          class="colorPill ma-1"
          :style="{ backgroundColor: currentTheme['secondary-darken-2'] }"
        >
          <div class="pb-0 colorDesc text-black-lighten-2">
            <div class="colorText">Pressed</div>
            <span class="colorCode">{{ currentTheme['secondary-darken-2'] }}</span>
          </div>
        </div>
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme.btnDelete }">
          <div class="pb-0 colorDesc text-white">
            <div class="colorText">Delete Default</div>
            <span class="colorCode">{{ currentTheme.btnDelete }}</span>
          </div>
        </div>
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme.btnDeleteHover }">
          <div class="pb-0 colorDesc text-white">
            <div class="colorText">Delete Hover</div>
            <span class="colorCode">{{ currentTheme.btnDeleteHover }}</span>
          </div>
        </div>
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme.btnDeletePress }">
          <div class="pb-0 colorDesc text-white">
            <div class="colorText">Delete Pressed</div>
            <span class="colorCode">{{ currentTheme.btnDeletePress }}</span>
          </div>
        </div>
        <div
          class="colorPill ma-1"
          :style="{ backgroundColor: currentTheme['secondary-darken-3'] }"
        >
          <div class="pb-0 colorDesc text-white">
            <div class="colorText">Info Border</div>
            <span class="colorCode">{{ currentTheme['secondary-darken-3'] }}</span>
          </div>
        </div>
        <div class="colorPill ma-1" :style="{ backgroundColor: currentTheme['black-lighten-5'] }">
          <div class="pb-0 colorDesc text-white">
            <div class="colorText">Info Pressed</div>
            <span class="colorCode">{{ currentTheme['black-lighten-5'] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CSButtonTest',

  data() {
    return {
      noOfClicks: 0,
      disabled: false,
      loading: false,
      longDescription:
        'This is a long description that should have lines more than 2. This is used to test information buttons with longer that a line'
    };
  },

  computed: {
    currentTheme() {
      return this.$vuetify.theme.themes[this.$vuetify.theme.name].colors;
    }
  },

  methods: {
    onClickMe() {
      this.noOfClicks += 1;
      this.disabled = !this.disabled;
    },
    onClickLoad() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
    }
  }
};
</script>
<style scoped>
.buttons-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.colorDefinition {
  border: 1px solid gray;
  width: 100%;
}
.colorDesc {
  min-width: 50px;
  color: white;
  font-size: 12px;
  text-align: center;
}
.colorPill {
  width: 100px;
  height: 50px;
  font-size: 10pt;
  border: 1px solid gray;
}
</style>
